window.AvailabilityMatrixForm = function (scope, applicationId) {
	var self = this;
	var formName = "availability-matrix-form";
	var _protected = BaseForm.call(self, formName, scope);
	
	self.data.matrix = {
		MON: {},
		TUE: {},
		WED: {},
		THU: {},
		FRI: {},
		SAT: {},
		SUN: {}
	};

	self.moment = moment;

	self.getDays = function () {
        var days = [];
        for (var i in self.data.matrix) {
            var day = {
                day: i,
                is_morning: self.data.matrix[i].is_morning,
                is_evening: self.data.matrix[i].is_evening
            };
            days.push(day);
        }

        return days;
    };

	self.getSelectedDays = function () {
        var days = [];
        for (var i in self.data.matrix) {
            if (self.data.matrix[i].is_morning || self.data.matrix[i].is_evening) {
                var day = {
                    day: self.data.matrix[i].day_fullname,
                    is_morning: self.data.matrix[i].is_morning,
                    is_evening: self.data.matrix[i].is_evening
                };
                days.push(day);
            }
        }

        return days;
    };

	self.save = function () {
        return AvailabilityMatrixAPI.save(applicationId, self.getDays());
	};
	
	self.load = function (matrix) {
		if (matrix && matrix.days && matrix.days.length) {
			for (var i in matrix.days) {
				self.data.matrix[matrix.days[i].day] = matrix.days[i];
			}
		}
	};

     self.getPreparedData = function () {
         return ({"days": self.getDays()});
     };

	self.validator.validateCustom = function (field, optionsField, rule, showError) {
		switch (rule.name) {
			case 'required_matrix':
				for (var i in self.data.matrix) {
					if (self.data.matrix[i] && (self.data.matrix[i].is_morning || self.data.matrix[i].is_evening)) {
						return true;
					}
				}
				return false;

				break;
		}
		
		return true;
	};
};
